import type { PrimativeLabelType, PrimitiveValueType } from './utils';

import { createValueMaps } from './utils';

export type OptionExtra = Record<string, unknown>;

export type Option<Value extends PrimitiveValueType, Extra extends OptionExtra | undefined = undefined> = Extra extends undefined ? {
    label: PrimativeLabelType;
    value: Value;
    disabled?: boolean;
    description?: string;
} : {
    label: PrimativeLabelType;
    value: Value;
    disabled?: boolean;
    description?: string;
} & Extra;

/**
 * Creates value conversion maps from option objects
 *
 * @param options - Array of option objects with value property
 * @returns Object containing maps for bidirectional conversion
 */
export function createValueMapsFromOptions<TValue extends PrimitiveValueType, TOption extends Option<TValue, OptionExtra>>(
    options: TOption[],
) {
    return createValueMaps(options.map(option => option.value));
}
